module.exports = __webpack_public_path__ + "img/ticket2.99821bc0.png";